export default __webpack_public_path__ + "static/media/b.f63d6b08.mp3";